var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorVarianceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gisColor0",
    transform: "translate(-27.789 -4888.35) scale(4.7619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gisColor1",
    display: "inline",
    transform: "translate(-318 -262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gisColor2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gisColor3",
    fill: "#000000",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1.105,
    d: "M333.191 1290.764c-5.526 0-9.355 4.421-9.355 6.632c0 2.21 1.105 3.868 3.315 3.868s3.316.553 3.316 2.21c0 2.211 1.658 3.869 3.869 3.869c7.184 0 10.5-3.869 10.5-7.737c0-6.632-5.013-8.842-11.645-8.842zm-1.475 2.21a1.382 1.382 0 1 1 0 2.764a1.382 1.382 0 0 1 0-2.764zm4.421 0a1.382 1.382 0 1 1 0 2.764a1.382 1.382 0 0 1 0-2.764zm4.001 2.211a1.382 1.382 0 1 1 0 2.763a1.382 1.382 0 0 1 0-2.763zm-12.29.265a1.382 1.382 0 1 1 0 2.764a1.382 1.382 0 0 1 0-2.764zm7.328 6.367c.915 0 1.658.742 1.658 1.657c0 .916-1.163 1.658-2.078 1.658a1.658 1.658 0 0 1-1.658-1.658c0-.915 1.162-1.657 2.078-1.657z",
    color: "currentColor",
    display: "inline",
    visibility: "visible"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorVarianceIcon);
export default __webpack_public_path__ + "static/media/ColorVarianceIcon.fc7bf671c7ec0c47a4216e7554cf11e5.svg";
export { ForwardRef as ReactComponent };